import gql from "graphql-tag";

const listTetapanBorang = gql`
  query tetapanBorangList($nama_borang: String) {
    tetapanBorangList(where: { nama_borang: $nama_borang }) {
      id
      jenis_borang
      nama_borang
      kod_borang
      perakuan
      medan_tambahan
    }
  }
`;

const viewTetapanBorang = gql`
  query tetapanBorangView($id: Float!) {
    tetapanBorangView(id: $id) {
      id
      jenis_borang
      nama_borang
      kod_borang
      perakuan
      medan_tambahan
    }
  }
`;

const updateTetapanBorang = gql`
  mutation tetapanBorangUpdate($input: UpdateTetapanBorangDto!) {
    tetapanBorangUpdate(input: $input) {
      id
      jenis_borang
      nama_borang
      kod_borang
      perakuan
      medan_tambahan
    }
  }
`;

export { listTetapanBorang, viewTetapanBorang, updateTetapanBorang };
